var map = {
	"./IMG-20170221-WA0005.jpg": 5897,
	"./IMG-20170221-WA0006.jpg": 2190,
	"./IMG-20170221-WA0007.jpg": 6971,
	"./IMG-20170221-WA0008.jpg": 1504,
	"./IMG-20170301-WA0056.jpg": 5752,
	"./IMG-20170301-WA0057.jpg": 3621,
	"./IMG-20170301-WA0058.jpg": 7078,
	"./IMG-20170301-WA0059.jpg": 211,
	"./IMG-20170301-WA0060.jpg": 4435,
	"./IMG-20170301-WA0061.jpg": 6022,
	"./IMG-20170301-WA0062.jpg": 1809
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4839;